
(function(app) {
    app.sectionpoint = (function() {
        var initialized = false;


        var classes = {
            current: 'current',
        };

        var selectors = {
            navItem :  '.go-href',
            section :  '.section'
        };

        var vars = {
            'gaps' : []
        };

        var init = function() {
            initialized = true;

            app.$objs.navItem = $(selectors.navItem);

            bind();
        };


        var bind = function() {

            findGaps();

            $(window).on('scroll', function () {
                if(app.windowSize()>1024) {
                    switchSmooth(vars.gaps);
                }
            });

        };

        var findGap = function (el) {
            var _el = el,
                $el = $(el),
                gap;

            gap = $el.offset().top;
            return gap;
        };

        var findGaps = function () {

            var sections = $(selectors.section),
                gapArray = {};

            $.each(sections, function (i,v) {

                var status = $(v).data('smooth');

                if(status == true) {
                    gapArray = { "element" : v.id , "top" : findGap(v)};

                    vars.gaps.push(gapArray);
                }

            });

        }

        var switchSmooth = function (obj) {
            var _obj = obj;

            var windowGap       = (document.documentElement && document.documentElement.scrollTop) ||document.body.scrollTop,
                sectionCount    = vars.gaps.length;

            windowGap+=350;

            for(i=0; i<sectionCount; i++) {
                if(_obj[i].top<= windowGap) {
                    app.$objs.navItem.removeClass(app.classes.current);
                    $('a[href*="#' + _obj[i].element).addClass(app.classes.current);

                } else {
                    $('a[href*="#"]' + _obj[i].element).removeClass(app.classes.current);
                }
            }
        };


        var isInitialized = function() {
            return initialized;
        };

        return {
            init:          init,
            isInitialized: isInitialized
        };
    })();

    app.registerInit('sectionpoint');
})(pc);
